// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__8O48x","footer":"ChangeClinic_footer__BlSg_"};